import { render, staticRenderFns } from "./FloatClaim.vue?vue&type=template&id=3dea51e0"
import script from "./FloatClaim.vue?vue&type=script&lang=js"
export * from "./FloatClaim.vue?vue&type=script&lang=js"
import style0 from "./FloatClaim.vue?vue&type=style&index=0&id=3dea51e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports